import React, { Component, Fragment } from "react";
import { Col, Form, Table } from "react-bootstrap";
import moment from "moment";
import { DEPENDENT_TYPE } from "./milestone.helper";
import { get, isEmpty } from "lodash";

class PreviewMilestone extends Component {
  render() {
    const {
      bucketMilestoneCOS = [],
      className,
      forDownload = false,
      data,
      cabinetMilestone
    } = this.props;
    return (
      <>
        <div
          data-test="success-milestone-container"
          className={`milestone-preview-container ${className} ${
            !forDownload ? "show-border" : ""
          }`}
        >
          {forDownload ? (
            <div className="download-milestone-header">
              <div className="heading-one">PROJECT MONITORING GROUP (PMG)</div>
              {get(data, "workflowType") !== "STATE" ? (
                <>
                  <div className="heading-two">
                    Department for Promotion of Industry and Internal Trade
                    (DPIIT)
                  </div>
                  <div className="heading-two">Government Of India</div>
                </>
              ) : null}
              <div className="heading-three">
                #PMG{get(data, "id")} - {get(data, "name", "NA")}
              </div>
            </div>
          ) : null}
          <h2 className="main-heading">Project Milestones</h2>
          {get(
            cabinetMilestone,
            "milestoneTableDataCOS[0].milestoneDataCOS",
            []
          ).length > 0 &&
            cabinetMilestone.disabled === false && (
              <>
                <h2 className="milestone-sub-heading">Cabinet Milestones</h2>
                <Form.Group className="milestone-table preview-table">
                  <Table className="table" cellPadding="10" cellSpacing="0">
                    <thead>
                      <tr>
                        <th className="no-border-bottom">S.No</th>
                        <th className="no-border-bottom">
                          Measurable Milestone / Activity
                        </th>
                        <th className="no-border-bottom">Status</th>
                        <th colSpan="2">Scheduled date of start</th>
                        <th colSpan="2">Scheduled date of finish</th>
                        <th className="no-border-bottom">
                          Responsible Agency/ Authority Involved
                        </th>
                        <th className="no-border-bottom">Dependency Type</th>
                        <th className="no-border-bottom">Linked to</th>
                      </tr>
                      <tr>
                        <th className="no-border-top" />
                        <th className="no-border-top" />
                        <th className="no-border-top" />
                        <th>Original</th>
                        <th>Revised/Actual</th>
                        <th>Original</th>
                        <th>Revised/Actual</th>
                        <th className="no-border-top" />
                        <th className="no-border-top" />
                        <th className="no-border-top" />
                      </tr>
                    </thead>

                    <tbody>
                      {cabinetMilestone.milestoneTableDataCOS[0].milestoneDataCOS.map(
                        (ms, idx) => (
                          <tr key={idx}>
                            <td>{idx + 1}</td>
                            <td>{ms.milestone && ms.milestone.name}</td>

                            <td>
                              {ms.disabled
                                ? "Disabled"
                                : ms.completed
                                ? "Completed"
                                : "Not completed"}
                            </td>

                            {ms.disabled ? (
                              <td className="disable-align" colSpan={7}>
                                {ms.disableReason}
                              </td>
                            ) : (
                              <>
                                <td>
                                  {ms.originalScheduledStartDate &&
                                    moment(
                                      ms.originalScheduledStartDate
                                    ).format("DD/MM/YYYY")}
                                </td>

                                <td>
                                  {ms.revisedScheduledStartDate &&
                                    moment(ms.revisedScheduledStartDate).format(
                                      "DD/MM/YYYY"
                                    )}
                                </td>

                                <td>
                                  {ms.originalScheduledFinishDate &&
                                    moment(
                                      ms.originalScheduledFinishDate
                                    ).format("DD/MM/YYYY")}
                                </td>

                                <td>
                                  {ms.revisedScheduledFinishDate &&
                                    moment(
                                      ms.revisedScheduledFinishDate
                                    ).format("DD/MM/YYYY")}
                                </td>

                                <td>
                                  {ms.responsibleAuthorityName === "Others"
                                    ? ms.otherResponsibleAuthority
                                    : ms.responsibleAuthorityName || "--"}
                                </td>

                                <td>
                                  {DEPENDENT_TYPE[ms.dependencyType] || "--"}
                                </td>

                                <td>
                                  {ms.dependencyType === "INDEPENDENT"
                                    ? "--"
                                    : ms.dependentOnName || "--"}
                                </td>
                              </>
                            )}
                          </tr>
                        )
                      )}
                    </tbody>
                  </Table>
                </Form.Group>
                <hr className="cabinet-milestone-separator" />
              </>
            )}
          <h2 className="milestone-sub-heading">PMG Milestones</h2>
          {!!bucketMilestoneCOS &&
            bucketMilestoneCOS.length > 0 &&
            bucketMilestoneCOS.map((bucket, idx1) => {
              return (
                <>
                  <h3 className="bucket-name">
                    {idx1 + 1}. {bucket.bucketName}
                  </h3>
                  <h3 className="status">
                    Status:{" "}
                    <span>
                      {!bucket.disabled
                        ? !bucket.completed
                          ? "Not Completed"
                          : "Completed"
                        : "Disabled"}
                    </span>
                  </h3>
                  {bucket.disabled && (
                    <h3 className="status">
                      Disable Reason: <span>{bucket.disableReason}</span>
                    </h3>
                  )}
                  {bucket && bucket.completed ? (
                    <div className="completed-details-wrapper">
                      {bucket.originalScheduledStartDate ? (
                        <div>
                          <span>Scheduled date of start (Original)</span>
                          {bucket.originalScheduledStartDate &&
                            moment(bucket.originalScheduledStartDate).format(
                              "DD/MM/YYYY"
                            )}
                        </div>
                      ) : null}
                      {bucket.revisedScheduledStartDate ? (
                        <div>
                          <span>Scheduled date of start (Revised/Actual)</span>
                          {bucket.revisedScheduledStartDate &&
                            moment(bucket.revisedScheduledStartDate).format(
                              "DD/MM/YYYY"
                            )}
                        </div>
                      ) : null}
                      {bucket.originalScheduledFinishDate ? (
                        <div>
                          <span>Scheduled date of finish (Original)</span>
                          {bucket.originalScheduledFinishDate &&
                            moment(bucket.originalScheduledFinishDate).format(
                              "DD/MM/YYYY"
                            )}
                        </div>
                      ) : null}
                      {bucket.revisedScheduledFinishDate ? (
                        <div>
                          <span>Scheduled date of finish (Revised/Actual)</span>
                          {bucket.revisedScheduledFinishDate &&
                            moment(bucket.revisedScheduledFinishDate).format(
                              "DD/MM/YYYY"
                            )}
                        </div>
                      ) : null}
                      {bucket.originalCost ? (
                        <div>
                          <span>
                            {bucket && bucket.bucketName === "Land Acquisition"
                              ? "Cost of Land Acquisition (Original)"
                              : "Cost of Construction (Original)"}
                          </span>
                          &#8377; {bucket.originalCost} Cr.
                        </div>
                      ) : null}
                      {bucket.revisedCost ? (
                        <div>
                          <span>
                            {bucket && bucket.bucketName === "Land Acquisition"
                              ? "Cost of Land Acquisition (Revised)"
                              : "Cost of Construction (Revised)"}
                          </span>
                          &#8377; {bucket.revisedCost} Cr.
                        </div>
                      ) : null}
                      {bucket.originalArea ? (
                        <div>
                          <span>Area of Land Acquisition (Original)</span>
                          {bucket.originalArea} Ha.
                        </div>
                      ) : null}
                      {bucket.revisedArea ? (
                        <div>
                          <span>Area of Land Acquisition (Revised)</span>
                          {bucket.revisedArea} Ha.
                        </div>
                      ) : null}
                    </div>
                  ) : null}
                  {!!bucket &&
                    !bucket.completed &&
                    bucket.milestoneTableDataCOS &&
                    bucket.milestoneTableDataCOS.map((table, idx2) => {
                      return (
                        <>
                          {!!table &&
                          !!table.milestoneTable &&
                          table.milestoneTable.name ? (
                            <h3 className="phase">
                              {table.milestoneTable.name}
                            </h3>
                          ) : null}
                          <div
                            className={`progress-percent ${
                              forDownload ? "download-progress-percent" : ""
                            }`}
                          >
                            {!!table && table.phaseName ? (
                              <h3 className="phase">
                                Phase Name: <span>{table.phaseName}</span>
                              </h3>
                            ) : null}
                            {!!table && table.phaseOriginalCost ? (
                              <h3 className="phase">
                                Original Cost:{" "}
                                <span>
                                  &#8377; {table.phaseOriginalCost} Cr.
                                </span>
                              </h3>
                            ) : null}
                            {!!table && table.phaseRevisedCost ? (
                              <h3 className="phase">
                                Original Cost:{" "}
                                <span>
                                  &#8377; {table.phaseRevisedCost} Cr.
                                </span>
                              </h3>
                            ) : null}
                            {!!table && table.physicalPercentage ? (
                              <h3 className="phase">
                                Physical Progress:{" "}
                                <span>{table.physicalPercentage}%</span>
                              </h3>
                            ) : null}
                            {!!table && table.financialPercentage ? (
                              <h3 className="phase">
                                Financial Progress:{" "}
                                <span>{table.financialPercentage}%</span>
                              </h3>
                            ) : null}
                            {!!table && table.asOfDate ? (
                              <h3 className="phase">
                                Progress As of Date:{" "}
                                <span>
                                  {moment(table.asOfDate).format("DD/MM/YYYY")}
                                </span>
                              </h3>
                            ) : null}
                            {get(table, "phaseProponent.name", "") ? (
                              <h3 className="phase">
                                Project Proponent:{" "}
                                <span>
                                  {get(table, "phaseProponent.name", "")}
                                </span>
                              </h3>
                            ) : null}
                          </div>
                          <Form.Group className="milestone-table preview-table">
                            <Table
                              className="table"
                              cellPadding="10"
                              cellSpacing="0"
                            >
                              <thead>
                                <tr>
                                  <th className="no-border-bottom">S.No</th>
                                  <th className="no-border-bottom">
                                    Measurable Milestone / Activity
                                  </th>
                                  <th className="no-border-bottom">Status</th>
                                  <th colSpan="2">Scheduled date of start</th>
                                  <th colSpan="2">Scheduled date of finish</th>
                                  <th className="no-border-bottom">
                                    Responsible Agency/ Authority Involved
                                  </th>
                                  <th className="no-border-bottom">
                                    Dependency Type
                                  </th>
                                  <th className="no-border-bottom">
                                    Linked to
                                  </th>
                                </tr>
                                <tr>
                                  <th className="no-border-top" />
                                  <th className="no-border-top" />
                                  <th className="no-border-top" />
                                  <th> Original</th>
                                  <th>Revised/Actual</th>
                                  <th>Original</th>
                                  <th>Revised/Actual</th>
                                  <th className="no-border-top" />
                                  <th className="no-border-top" />
                                  <th className="no-border-top" />
                                </tr>
                              </thead>
                              <tbody>
                                {!!table &&
                                  table.milestoneDataCOS.length > 0 &&
                                  table.milestoneDataCOS.map((ms, idx3) => {
                                    return (
                                      <Fragment>
                                        {!ms.disabled ? (
                                          <tr>
                                            <td>{idx3 + 1}</td>
                                            <td>{ms.milestone.name}</td>
                                            <td>
                                              {!ms.completed
                                                ? "Not completed"
                                                : "Completed"}
                                            </td>
                                            <td>
                                              {!!ms.originalScheduledStartDate &&
                                                moment(
                                                  ms.originalScheduledStartDate
                                                ).format("DD/MM/YYYY")}
                                            </td>
                                            <td>
                                              {!!ms.revisedScheduledStartDate &&
                                                moment(
                                                  ms.revisedScheduledStartDate
                                                ).format("DD/MM/YYYY")}
                                            </td>
                                            <td>
                                              {!!ms.originalScheduledFinishDate &&
                                                moment(
                                                  ms.originalScheduledFinishDate
                                                ).format("DD/MM/YYYY")}
                                            </td>
                                            <td>
                                              {!!ms.revisedScheduledFinishDate &&
                                                moment(
                                                  ms.revisedScheduledFinishDate
                                                ).format("DD/MM/YYYY")}
                                            </td>
                                            <td>
                                              {ms.responsibleAuthorityName ===
                                              "Others"
                                                ? ms.otherResponsibleAuthority
                                                : ms.responsibleAuthorityName}
                                            </td>
                                            <td>
                                              {
                                                DEPENDENT_TYPE[
                                                  ms.dependencyType
                                                ]
                                              }
                                            </td>
                                            <td>
                                              {ms.dependencyType ==
                                              "INDEPENDENT"
                                                ? "--"
                                                : ms.dependentOnName}
                                            </td>
                                          </tr>
                                        ) : (
                                          <tr>
                                            <td>{idx3 + 1}</td>
                                            <td>{ms.milestone.name}</td>
                                            <td>{" Disabled "}</td>
                                            <td
                                              className="disable-align"
                                              colSpan={7}
                                            >
                                              {ms.disableReason}
                                            </td>
                                          </tr>
                                        )}
                                      </Fragment>
                                    );
                                  })}
                              </tbody>
                            </Table>
                          </Form.Group>
                        </>
                      );
                    })}
                </>
              );
            })}
        </div>
      </>
    );
  }
}

export default PreviewMilestone;
